import { useTheme } from '@mui/styles';

export const DaySelectionStyle = () => {
  const theme = useTheme();
  return {
    selectStyle: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'dana-bold'
    },
    select: {
      background: '#F4F4F4',
      border: '1px solid #FFFFFF',
      boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)',
      borderRadius: '12px ',
      width: '189px',
      marginTop: '0.2rem',
      '& ul': {
        display: 'grid',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
          padding: '32px 16px'
        }
      },
      '& li': {
        width: '170px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#FFFFFF',
        border: '1px solid #EEEEEE',
        boxShadow: '-2px -2px 10px #FFFFFF, 4px 4px 25px rgba(0, 0, 0, 0.08)',
        borderRadius: '12px',
        margin: '6px 0',
        fontWeight: '400',
        fontSize: '12px',
        height: '30px ',
        minHeight: '30px',
        paddingTop: ' 9px ',
        color: '#707070',
        '&:hover': {
          border: '1px solid #753CBE',
          background: '#FFFFFF !important',
          color: '#753CBE !important'
        },
        [theme.breakpoints.up('md')]: {
          height: '64px',
          width: '315px',
          fontSize: '24px',
          margin: '12px 0 0'
        }
      }
    },
    ItemSelected: {
      background: '#FFFFFF !important',
      border: '1px solid #753CBE !important',
      transform: 'scale(1) !important',
      color: '#753CBE !important'
    },
    numberWeight: {
      display: 'inline',
      fontFamily: 'dana-bold',
      marginLeft: '.1rem'
    }
  };
};
